import { DotLegalDialog, DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import useRiskManagementReportDialogHooks from "./RiskManagementReportDialog.hooks";

export interface IRiskManagementReportDialogProps {
    onDialogClose: () => void;
}

function RiskManagementReportDialog(props: IRiskManagementReportDialogProps) {
    const { translateString } = useTranslation();
    const { saveModel, onNoteChange, onDownloadPdfClick, isDownloadingPdf } = useRiskManagementReportDialogHooks(props);

    return (
        <DotLegalDialog
            size="md"
            header={translateString("riskManagementReportDialogHeader")}
            buttonOkText={translateString("downloadPdf")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onDownloadPdfClick}
            inProgress={isDownloadingPdf}
        >
            <Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <DotLegalHeader center fontWeight={400} headerStyle={"small"} marginBottom={2}>
                        {translateString("riskManagementReportDownloadInfo")}
                    </DotLegalHeader>
                </Box>
                <DotLegalTextField
                    multiline
                    rows={3}
                    label={translateString("writeANote")}
                    value={saveModel.note ?? null}
                    onChange={onNoteChange}
                    debounce={false}
                />
            </Box>
        </DotLegalDialog>
    );
}

export default RiskManagementReportDialog;
